module.exports = __webpack_public_path__ + "img/lectorasconteos.43fea077.png";